import React, { useState } from 'react';
import { Button, Form, Input, Radio, Upload, message } from 'antd';
import { StyledButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import { FormLabel } from 'pages/settings_page/style';
import { UploadOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { createEndpoint, getEndpoints } from 'redux/slices/endpointsSlice';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { InputPatternRuleEndpointDomain } from 'utils/input_pattern';

const normFile = (e) => {
  if (Array.isArray(e)) {
    return e;
  }
  return e?.fileList;
};

const CreateEndpoint = ({ setModal }) => {
  const dispatch = useDispatch();
  const [protocol, setProtocol] = useState('http');
  const [uploadedfile, setUploadedfile] = useState([]);

  const onFinish = async (values) => {
    const formData = new FormData();
    formData.append('protocol', values.protocol);
    formData.append('domain', values.domain);
    formData.append('port', values.port);
    formData.append('password', protocol === 'https' ? values.password : '');
    formData.append('file', protocol === 'https' ? values.sslCertificate[0].originFileObj : '');
    try {
      const response = await dispatch(createEndpoint(formData));
      if (response?.payload.status === 200) {
        SweetSweetAlert({ sweetData: response.payload.data.message, icon: 'success', buttonColor: 'green' });
        setModal(false);
        dispatch(getEndpoints());
      } else if (response?.payload.status === 409) {
        SweetSweetAlert({ sweetData: response.payload.data, icon: 'error', buttonColor: 'red' });
      } else {
        SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      return error;
    }
  };

  const handleFileChange = ({ fileList }) => {
    setUploadedfile(fileList);
  };

  return (
    <div className='af-modal-wrap af-modal-wrap-endpoint'>
      <h2 className='af-form-header af-add_endpoints-form-header'>Add Endpoint</h2>
      <Form
        className='af-form af-add_endpoints-form'
        name='endpoints'
        onFinish={onFinish}
        initialValues={{
          protocol: protocol,
          domain: '',
          port: 6060,
          password: '',
        }}
      >
        <FormLabel
          className='formItemEvenLine af-form-item af-add_endpoints-form-item af-add_endpoints-form-item-protocol'
          name='protocol'
          label='Protocol:'
          rules={[
            {
              required: true,
              message: 'Please Enter this Field',
            },
          ]}
        >
          <Radio.Group
            className='af-form-radio af-add_endpoints-form-radio af-add_endpoints-form-protocol'
            onChange={(e) => setProtocol(e.target.value)}
          >
            <Radio
              className='af-form-radio-option af-add_endpoints-form-radio-option af-add_endpoints-form-radio-option_protocol'
              value={'http'}
            >
              http
            </Radio>
            <Radio
              className='af-form-radio-option af-add_endpoints-form-radio-option af-add_endpoints-form-radio-option_protocol'
              value={'https'}
            >
              https
            </Radio>
          </Radio.Group>
        </FormLabel>
        <FormLabel
          name='domain'
          className='formItemEvenLine af-form-item af-add_endpoints-form-item af-add_endpoints-form-item-domain'
          label='Domain:'
          rules={[
            {
              required: true,
              message: 'Please Enter this Field',
            },
            {
              pattern: InputPatternRuleEndpointDomain.pattern,
              message: InputPatternRuleEndpointDomain.message,
            },
          ]}
        >
          <Input className='af-form-input af-add_endpoints-form-input af-add_endpoints-form-input_domain' />
        </FormLabel>
        <FormLabel
          name='port'
          className='formItemEvenLine af-form-item af-add_endpoints-form-item af-add_endpoints-form-item-port'
          label='Port:'
          rules={[
            {
              required: true,
              message: 'Please Enter this Field',
            },
          ]}
        >
          <Input className='af-form-input af-add_endpoints-form-input af-add_endpoints-form-input_port' type='number' />
        </FormLabel>
        {protocol === 'https' && (
          <>
            <FormLabel
              name='sslCertificate'
              className='formItemEvenLine af-form-item af-add_endpoints-form-item af-add_endpoints-form-item-ssl_certificate'
              label='SSL Certificate:'
              valuePropName='fileList'
              getValueFromEvent={normFile}
              style={{ marginBottom: 10 }}
            >
              <Upload
                className='af-form-upload af-add_endpoints-form-upload af-add_endpoints-form-upload_ssl_certificate'
                accept='.pfx,.pem,.cer,.crt'
                beforeUpload={(file) => {
                  const validExtensions = ['.pfx', '.pem', '.cer', '.crt'];
                  const fileExtension = file.name.slice(((file.name.lastIndexOf('.') - 1) >>> 0) + 2).toLowerCase();

                  if (!validExtensions.includes('.' + fileExtension)) {
                    message.error(`${file.name} is not a .pfx, .pem, .cer, or .crt file`);
                    return false || Upload.LIST_IGNORE;
                  }
                  return true;
                }}
                onChange={handleFileChange}
                maxCount={1}
                fileList={uploadedfile}
              >
                <Button
                  className='af-form-upload-button af-add_endpoints-form-upload-button af-add_endpoints-form-upload-button_ssl_certificate'
                  icon={<UploadOutlined />}
                >
                  Upload
                </Button>
              </Upload>
            </FormLabel>
            <FormLabel
              name='depend_file'
              label='depend'
              className='formItemEvenLine hidden_label visible-hidden af-form-item af-add_endpoints-form-item af-add_endpoints-form-item-depend_file'
            >
              <span className='af-form-caption af-form-caption-add_endpoints' style={{ color: 'red' }}>
                Only Upload the '.pfx'/'.pem'/'.cer'and'.crt' files
              </span>
            </FormLabel>
            <FormLabel
              name='password'
              className='formItemEvenLine af-form-item af-add_endpoints-form-item af-add_endpoints-form-item-password'
              label='Password:'
            >
              <Input.Password className='af-form-input af-add_endpoints-form-input af-add_endpoints-form-input_passowrd' />
            </FormLabel>
          </>
        )}

        <FormLabel
          className='af-form-button-submit-wrapper af-add_endpoints-form-button-submit-wrapper'
          style={{ textAlign: 'end' }}
        >
          <StyledButton
            type='primary'
            htmlType='submit'
            className='af-form-button af-add_endpoints-form-button af-add_endpoints-form-button_submit'
          >
            Add Endpoint
          </StyledButton>
        </FormLabel>
      </Form>
    </div>
  );
};

export default CreateEndpoint;
